import React, { FC, useEffect, useState } from 'react';
import GenericModal from './GenericModal';
import CheckCoverageComponent from './CheckCoverage';
import { viewport } from '../../utils/utils';

const CoverageCheckModal: FC<any> = ({
  content,
  onSuccess,
  showModal,
  setShowModal,
  productName,
  overlayIsOpen,
  lineCheckOnClear,
  onCreateCart,
  productId
}) => {
  const handleClick = () => {
    setShowModal(false);
  };

  const viewPort = viewport();

  const [backgroundColor, setBackgroundColor] = useState<string>('');
  const [fixedWidth, setFixedWidth] = useState<string>('');
  const [height, setHeight] = useState<string>('');

  useEffect(() => {
    const isMobile = viewPort === 'mobile' ? true : false;
    const backgroundColorValue = isMobile ? 'white' : 'transparent';
    const fixedWidthValue = isMobile ? 'auto' : '850px';
    const heightValue = isMobile ? '100vh' : 'auto';
    setBackgroundColor(backgroundColorValue);
    setFixedWidth(fixedWidthValue);
    setHeight(heightValue);
  }, [viewPort, productName]);

  return (
    <GenericModal
      modalState={showModal}
      handler={handleClick}
      showFooter={false}
      noCloseButton={true}
      backgroundColor={backgroundColor}
      fixedWidth={fixedWidth}
      bodyPadding='0'
      height={height}
      isMobile={viewPort === 'mobile' ? true : false}
    >
      <CheckCoverageComponent
        content={content}
        productName={productName}
        overlayIsOpen={overlayIsOpen}
        openModal={true}
        handleModal={handleClick}
        onSuccess={onSuccess}
        lineCheckOnClear={lineCheckOnClear}
        isModal={true}
        onCreateCart={onCreateCart}
        setShowModal={setShowModal}
        productId={productId}
      />
    </GenericModal>
  );
};

export default CoverageCheckModal;
